import { Component, computed, input } from '@angular/core'
import { LocalTimeRange } from '@ftr/contracts/type/shared'
import { TooltipModule } from '@ftr/foundation'
import { formatRequestTimeRange } from '../../../utils'

@Component({
  selector: 'ftr-request-times-display',
  templateUrl: './request-times-display.component.html',
  styleUrl: './request-times-display.component.css',
  imports: [TooltipModule],
})
export class RequestTimesDisplayComponent {
  readonly times = input.required<LocalTimeRange[]>()
  readonly maxVisible = input<number, number>(undefined, {
    transform: value => (value !== undefined ? Math.max(1, value) : undefined),
  })
  readonly isStacked = input<boolean>(false)

  protected readonly formattedTimes = computed<string[]>(() =>
    this.times()
      .toSorted((a, b) => a.start.compareTo(b.start))
      .map(formatRequestTimeRange),
  )

  protected readonly splitTimes = computed<{ visible: string[]; truncated: string[] }>(() => {
    const formattedTimes = this.formattedTimes()

    if (!formattedTimes.length) return { visible: [], truncated: [] }

    const maxVisible = this.maxVisible()

    if (!maxVisible) return { visible: formattedTimes, truncated: [] }

    const visible = formattedTimes.slice(0, maxVisible)
    const truncated = formattedTimes.slice(maxVisible)

    return { visible, truncated }
  })
}
